import React, { useContext, useEffect } from 'react';
import * as S from './styles';
import { Context } from '../../services/contexts/StateContext';
import api from '../../services/api';

import { ModalUsuario } from '../../componentes/Modal/ModalUsuario';
import { ListaUsuario } from '../../componentes/ListarPesquisas/ListaUsuario';
import { PesquisaPadrao } from '../../componentes/Pesquisas/PesquisaPadrao';
import LoadingContent from '../../componentes/loading/loading';

function Usuario({
    alertDelete,
    BuscaTodosUsuarios,
    ExcluirEste,
    FecharAlerte,
    FecharModal,
    Play_Modal_Add,
    setAletDelete,
    setNewStatus,
    setRefDelet,
}) {
    const { state, dispatch } = useContext(Context);
    const { usuario } = state.cliente;
    const { parametroInit, displayModal, playmodal, listaPesquisa, playLista } = state.parametros;
    const { pesquisaIdUsuario, loading } = parametroInit;
    const { id_Usuario } = usuario;
    const { listaUsuario } = listaPesquisa;

    useEffect(() => {
        if (displayModal.usuarioDisplay) {
            BuscaTodosUsuarios();
        }
    }, [displayModal.usuarioDisplay]);

    useEffect(() => {
        if (pesquisaIdUsuario) {
            pesqIdUsuario();
        }
    }, [pesquisaIdUsuario]);

    async function pesqIdUsuario() {
        if (id_Usuario) {
            await api.get(`/usuario/id/${id_Usuario}`)
                .then(res => {
                    dispatch({
                        type: 'set_ListaPesquisa',
                        payload: { ...listaPesquisa, listaUsuario: [res.data] }
                    });
                    dispatch({
                        type: 'set_playLista',
                        payload: { ...playLista, playListaUsuario: true }
                    });
                    dispatch({
                        type: 'SET_parametroInit',
                        payload: { ...parametroInit, pesquisaIdUsuario: false }
                    });
                });
        }
    }

    async function PesqNomeCpfUsuario(nome) {
        const termoBusca = (nome || '').trim();

        if (termoBusca) {
            dispatch({
                type: 'SET_parametroInit',
                payload: { ...parametroInit, loading: true }
            });

            await api.get(`/usuario/${termoBusca}`)
                .then(res => {
                    dispatch({
                        type: 'SET_parametroInit',
                        payload: { ...parametroInit, loading: false }
                    });
                    dispatch({
                        type: 'set_playLista',
                        payload: { ...playLista, playListaUsuario: true }
                    });
                    dispatch({
                        type: 'set_ListaPesquisa',
                        payload: { ...listaPesquisa, listaUsuario: res.data }
                    });
                });
        } else {
            BuscaTodosUsuarios();
        }

        dispatch({
            type: 'SET_PLAYMODAL',
            payload: { ...playmodal, playModalUsuario: false }
        });
    }

    if (!displayModal.usuarioDisplay) {
        return null;
    }

    return (
        <S.ContainerLista>
            <S.containerPesq>
                <PesquisaPadrao
                    refNomeCPF={true}
                    Lupa={true}
                    playBotao={true}
                    Pesquisar={PesqNomeCpfUsuario}
                    playModal_Add={Play_Modal_Add}
                    titulo="Buscar Usuario"
                    placeholder="nome ou cpf"
                    nomeBotao="Novo Usuario"
                    PesqDentroModal={false}
                    PesquisarData={() => { }}
                    mostrarFiltroData={false}
                    mostrarMais={false}
                />
            </S.containerPesq>

            <S.ModalConteine>
                {loading && !playmodal.playModalUsuario &&
                    <S.bodyresult>
                        <LoadingContent />
                    </S.bodyresult>
                }

                {!loading &&
                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                        <ListaUsuario
                            titulo="Usuarios"
                            listaBusca={listaUsuario}
                            setAletDelete={setAletDelete}
                            alertDelete={alertDelete}
                            setNewStatus={setNewStatus}
                            setRefDelet={setRefDelet}
                            pesqTodos={BuscaTodosUsuarios}
                            ExcluirEste={ExcluirEste}
                            FecharAlerte={FecharAlerte}
                        />
                    </div>
                }
                {playmodal.playModalUsuario &&
                    <S.Modal>
                        <ModalUsuario
                            FecharModal={FecharModal}
                            playModal_Add={Play_Modal_Add}
                        />
                    </S.Modal>
                }
            </S.ModalConteine>
        </S.ContainerLista>
    );
}

export default Usuario;
